import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/image-Picsart-AiImageEnhancer-Photoroom.png";
import Toolstack from "./Toolstack";
import Databases from "./Databases";
import VersionControl from "./VersionControl";
import Deployments from "./Deployments";
import AIBOTS from "./AIBOTS";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "0px", paddingBottom: "50px", zIndex: 100 }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <h1 className="project-heading">
          <strong className="purple">Databases</strong> I use
        </h1>
        <Databases />

        <h1 className="project-heading">
          <strong className="purple">Cloud Platforms</strong> I use
        </h1>
        <Deployments />

        <h1 className="project-heading">
          <strong className="purple">AI tools</strong> I use
        </h1>
        <AIBOTS/>

        <h1 className="project-heading">
          <strong className="purple">version Control</strong> I use
        </h1>
        <VersionControl />
      </Container>
    </Container>
  );
}

export default About;
